/**
 * @generated SignedSource<<b241bb5fc11378db729cbb09ca87a1e8>>
 * @relayHash c9b8f156814615ff82eb2393351e0719
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c9b8f156814615ff82eb2393351e0719

import type { ConcreteRequest } from 'relay-runtime';
export type IssueEventConfidenceLevel = "HIGH" | "LOW" | "MEDIUM" | "%future added value";
export type IssueFieldSingleSelectOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type UpdateIssueFieldValueInput = {
  clientMutationId?: string | null | undefined;
  issueField: IssueFieldCreateOrUpdateInput;
  issueId: string;
};
export type IssueFieldCreateOrUpdateInput = {
  confidence?: IssueEventConfidenceLevel | null | undefined;
  dateValue?: string | null | undefined;
  delete?: boolean | null | undefined;
  fieldId: string;
  multiSelectOptionIds?: ReadonlyArray<string> | null | undefined;
  numberValue?: number | null | undefined;
  rationale?: string | null | undefined;
  singleSelectOptionId?: string | null | undefined;
  suggest?: boolean | null | undefined;
  textValue?: string | null | undefined;
};
export type updateIssueFieldValueMutation$variables = {
  input: UpdateIssueFieldValueInput;
};
export type updateIssueFieldValueMutation$data = {
  readonly updateIssueFieldValue: {
    readonly issue: {
      readonly id: string;
    } | null | undefined;
    readonly issueFieldValue: {
      readonly color?: IssueFieldSingleSelectOptionColor;
      readonly description?: string | null | undefined;
      readonly id?: string;
      readonly name?: string;
      readonly numberValue?: number;
      readonly value?: string;
    } | null | undefined;
  } | null | undefined;
};
export type updateIssueFieldValueMutation = {
  response: updateIssueFieldValueMutation$data;
  variables: updateIssueFieldValueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "IssueFieldTextValue",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "IssueFieldSingleSelectValue",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "IssueFieldDateValue",
  "abstractKey": null
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": "numberValue",
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "type": "IssueFieldNumberValue",
  "abstractKey": null
},
v8 = [
  (v2/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateIssueFieldValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateIssueFieldValuePayload",
        "kind": "LinkedField",
        "name": "updateIssueFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "issueFieldValue",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateIssueFieldValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateIssueFieldValuePayload",
        "kind": "LinkedField",
        "name": "updateIssueFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "issueFieldValue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v8/*: any*/),
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v9/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c9b8f156814615ff82eb2393351e0719",
    "metadata": {},
    "name": "updateIssueFieldValueMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "42fa492eab38e97eb091a4309e4f4202";

export default node;
